import { routerReducer } from 'react-router-redux';
import { combineReducers } from 'redux';

import * as Constants from '../constants';

import apiReducer from './Api';
import browseGenresReducer from './BrowseGenres';
import capabilitiesReducer from './Capabilities';
import ClientInfoReducer from './ClientInfo';
import dropdownReducer from './Dropdown';
import entityReducer from './entities/index';
import feedbackReducer from './Feedback';
import feedbackT3Reducer from './FeedbackT3';
import formReducer from './Form';
import i18nReducer from './i18n';
import loginReducer from './Login';
import myStationsReducer from './MyStations';
import nowPlayingReducer from './NowPlaying';
import OverlayReducer from './Overlay';
import registerReducer from './Register';
import scrollReducer from './Scroll';
import smartConversionReducer from './SmartConversion';
import stationDetailsReducer from './StationDetails';
import stationNarrativeReducer from './StationNarrative';
import storageReducer from './Storage';
import StoreGarbageCollector from './StoreGarbageCollector';
import tunerVarsReducer from './TunerVars';
import uiReducer from './UI';
import usageReducer from './Usage';
import userAccountReducer from './UserAccount';
import userProfileReducer from './UserProfile';

/* build reducer dictionary */
// Please keep these in alphabetical order so they're displayed in order in
// redux devtools
export const reducerDict = {
  api: apiReducer,
  browseGenres: browseGenresReducer,
  capabilities: capabilitiesReducer,
  clientInfo: ClientInfoReducer,
  dropdown: dropdownReducer,
  feedback: feedbackReducer,
  feedbackT3: feedbackT3Reducer,
  form: formReducer,
  i18n: i18nReducer,
  login: loginReducer,
  myStations: myStationsReducer,
  nowPlaying: nowPlayingReducer,
  overlay: OverlayReducer,
  register: registerReducer,
  routing: routerReducer,
  scroll: scrollReducer,
  smartConversion: smartConversionReducer,
  stationDetails: stationDetailsReducer,
  stationNarrative: stationNarrativeReducer,
  storage: storageReducer,
  tunerVars: tunerVarsReducer,
  ui: uiReducer,
  userAccount: userAccountReducer,
  userProfile: userProfileReducer,
  // PERFORMANCE OPTIMIZATION: Sorry alphabetical order, but keeping entities & listeners reducer last,
  // means that redux-persist will process these last when doing batch writes to local storage
  // this helps initial page load since these are quite large.
  entities: entityReducer,
  usage: usageReducer,
};

export function buildRootReducer(asyncReducers = {}) {
  const combinedReducer = combineReducers({
    ...reducerDict,
    ...asyncReducers,
  });
  return (state = {}, action) => {
    if (action.type === Constants.App.AppActions.UPLOAD_STORE) {
      return action.data.store;
    }
    return StoreGarbageCollector(combinedReducer(state, action), action);
  };
}

const rootReducer = buildRootReducer();

export default rootReducer;
